import { saveSpreadsheet } from '../../../utils/spreadsheet/save';
import { type KpiResponseDto } from '../types';

export const kpiDataExporter =
  (kpi: KpiResponseDto) => async (kpiEntries: any) => {
    const mapped = kpiEntries.map((p: any) => {
      return {
        'KPI ID': p.kpiId,
        'KPI name': kpi.name,
        // Should (roughly) match the fields in the CSV import
        'Unit name': p.assigneeUnitName,
        Target: p.latestTarget,
        Actual: p.latestActual,
        Performance: p.performance,
        Score: p.latestScore,
        'Last updated': p.lastUpdated,
      };
    });

    await saveSpreadsheet({
      format: 'csv',
      data: mapped,
      basename: `${kpi.name} - KPI data`,
    });
  };
